import * as React from 'react';
import { withTranslation, WithTranslation } from "react-i18next";
import Messages from '../Messages/messages';
import DraftMessages from '../DraftMessages/draftMessages';
import './tabContainer.scss';
import ScheduledMessages from '../ScheduledMessages/scheduledMessages';
import { app, dialog, UrlDialogInfo } from "@microsoft/teams-js";
import { getBaseUrl } from '../../configVariables';
import { getDraftMessagesList, getMessagesList, getScheduledMessagesList } from '../../actions';
import { connect } from 'react-redux';
import { TFunction } from "i18next";
import ExportButton from './exportButton/ExportButton';
import { Button, Accordion, AccordionItem, AccordionHeader, AccordionPanel } from "@fluentui/react-components";
import { ArrowLeft24Filled, ArrowRight24Filled} from '@fluentui/react-icons';

interface ITaskInfo {
    title?: string;
    height?: number;
    width?: number;
    url?: string;
    card?: string;
    fallbackUrl?: string;
    completionBotId?: string;
}

export interface ITaskInfoProps extends WithTranslation {
    getDraftMessagesList?: any;
    getScheduledMessagesList?: any;
    getMessagesList?: any;
}

export interface ITabContainerState {
    url: string;
    pageNumber: number;
    pageToken: any[];
}

class TabContainer extends React.Component<ITaskInfoProps, ITabContainerState> {
    readonly localize: TFunction;
    constructor(props: ITaskInfoProps) {
        super(props);
        this.localize = this.props.t;
        this.state = {
            url: getBaseUrl() + "/newmessage?locale={locale}",
            pageNumber: 1,
            pageToken: [{ nextPartitionKey: "", nextRowKey: "" }]
        }
        this.escFunction = this.escFunction.bind(this);
    }

    public async componentDidMount() {
        await app.initialize();
        //- Handle the Esc key
        document.addEventListener("keydown", this.escFunction, false);
    }

    public componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunction, false);
    }

    public escFunction(event: any) {
        if (event.keyCode === 27 || (event.key === "Escape")) {
            dialog.url.submit();
        }
    }

    public handleTokenCallback = (tokenData: any) => {
        if (tokenData !== null) {
            let nextPartitionKey = tokenData.nextPartitionKey;
            let nextRowKey = tokenData.nextRowKey;
            if (!this.state.pageToken.find(x => x.nextPartitionKey == nextPartitionKey && x.nextRowKey == nextRowKey)) {
                this.setState({
                    pageToken: [...this.state.pageToken, { nextPartitionKey: nextPartitionKey, nextRowKey: nextRowKey }]
                });
            }
        }
    }
    private resetPage = (reset: boolean) => {
        if (reset) {
            this.setState({
                pageNumber: 1,
                pageToken: [{ nextPartitionKey: "", nextRowKey: "" }]
            })
        }
    }

    private wrapAccordionItem = (value: string, title: string, children: JSX.Element): JSX.Element => {
        return <AccordionItem value={value}>
            <AccordionHeader>{title}</AccordionHeader>
            <AccordionPanel>
                {children}
            </AccordionPanel>
        </AccordionItem>
    }

    public render(): JSX.Element {
        const draftPanel = <div className="messages">
            <DraftMessages resetPageCallback={this.resetPage}></DraftMessages>
        </div>

        const scheduledPanel = <div className="messages">
            <ScheduledMessages></ScheduledMessages>
        </div>

        const sentPanel = <>
            <ExportButton />
            <div className="messages">
                <Messages parentCallback={this.handleTokenCallback}></Messages>
            </div>
            <div style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap", justifyContent: "space-between" }}>
                <Button icon={<ArrowLeft24Filled/>} iconPosition='before' disabled={this.state.pageNumber == 1} style={{ margin: "2rem" }} onClick={this.onPreviousPage} appearance='primary' color="accent" >Previous Page</Button>
                <span style={{ marginTop: "2.5rem", fontWeight: "bold" }} >Page {this.state.pageNumber}</span>
                <Button icon={<ArrowRight24Filled/>} iconPosition='after' disabled={!this.state.pageToken[this.state.pageNumber]} style={{ margin: "2rem" }} onClick={this.onNextPage} appearance='primary' color="accent" >Next Page</Button>
            </div>
        </>

        return (
            <div className="tabContainer">
                <div className="messageContainer">
                    <Accordion defaultOpenItems={["draft", "scheduled"]} multiple>
                        {this.wrapAccordionItem("draft", this.localize('DraftMessagesSectionTitle'), draftPanel)}
                        {this.wrapAccordionItem("scheduled", this.localize('ScheduledMessagesSectionTitle'), scheduledPanel)}
                        {this.wrapAccordionItem("sent", this.localize('SentMessagesSectionTitle'), sentPanel)}
                    </Accordion>
                </div>
            </div>
        );
    }

    public onNextPage = () => {
        let currentPage = this.state.pageNumber;
        let token = this.state.pageToken[currentPage];
        let nextPartitionKey = token.nextPartitionKey;
        let nextRowKey = token.nextRowKey;
        this.props.getMessagesList(nextPartitionKey, nextRowKey).then(() => {
            this.setState({
                pageNumber: currentPage + 1
            });
        });
    }
    public onPreviousPage = () => {
        let currentPage = this.state.pageNumber - 1;
        let token = this.state.pageToken[currentPage - 1];
        let nextPartitionKey = token.nextPartitionKey;
        let nextRowKey = token.nextRowKey;
        this.props.getMessagesList(nextPartitionKey, nextRowKey).then(() => {
            this.setState({
                pageNumber: currentPage
            });
        });
    }

    public onNewMessage = () => {
        let urlDialogInfo: UrlDialogInfo = {
            url: this.state.url,
            title: this.localize("NewMessage"),
            size: {
                height: 660,
                width: 1000
            },
            fallbackUrl: this.state.url,
        }

        let submitHandler = (result: dialog.ISdkResponse) => {
            this.props.getDraftMessagesList().then(() => {
                setTimeout(this.props.getScheduledMessagesList(), 1000)
            })

        };

        dialog.url.open(urlDialogInfo, submitHandler);
    }
}

const mapStateToProps = (state: any) => {
    return { messages: state.draftMessagesList };
}

const tabContainerWithTranslation = withTranslation()(TabContainer);
export default connect(mapStateToProps, { getDraftMessagesList, getMessagesList, getScheduledMessagesList })(tabContainerWithTranslation);